// 💾 src/pages/admin/components/sections/SettingsPanel.tsx
const SettingsPanel = () => {
  return <div className="admin-panel">⚙️ Admin Settings</div>
}

export default SettingsPanel
